import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function

const createNewMember = async (
  orgid,
  email,
  prenom,
  role,
  org_admin,
  token,
  prefix
) => {
  // Define the endpoint URL
  const url = `${prefix}organisations/${orgid}/member`;

  // Define the request body
  const body = {
    prenom,
    email,
    role: role,
    org_admin: org_admin,
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");
    let end = new Date();
    let elapsed = end - start;
    const responseText = await response.text();
    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "", // Optional additional fields
      "",
      JSON.stringify(body),
      responseText,
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      const result = JSON.parse(responseText);
      const id = result?.user_created?.id ?? "ID";
      return id;
    } else {
      return `Failed to create user: ${response.status}`;
    }
  } catch (error) {
    return `Exception occurred: ${error.message}`;
  }
};

export default createNewMember;
